import React, { useState } from 'react';
import * as DateFns from 'date-fns';

import DatePicker from '../Shared/DatePicker/DatePicker';
import TimeSelector from '../Shared/TimeSelector';
import { useEffect } from 'react';
import { cleanControllerSet, isEmptyObject } from '../../helpers/helpers';
import { CONTROLLER_SET } from '../../config/constants';
import { EditStartProps } from './types';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import { updatePracticeData } from 'store/actions';
import { usePracticeDataUpdateDispatch } from 'store/hooks';

const EditStartTimeButton = ({ date, practice, editPracticeTime, disabled } : EditStartProps) => {
  const practiceDataUpdate  = useSelector((state: RootState) => state.practiceDataUpdate.practiceDataUpdate);
  const { noSave } = usePracticeDataUpdateDispatch();
  const [componentDate, setComponentDate] = useState<Date | number | undefined>(practiceDataUpdate.start || date);
  const [currentPractice, setCurrentPractice] = useState(practice);
  useEffect(() => {
    if (!!practice && !isEmptyObject(practice)) {
      setCurrentPractice(practice);
    }
  }, [practice]);

  const correctHour = (am: boolean, hour: number) => {
    if (am === true) {
      if (hour === 12) {
        hour = 0;
      }
    } else {
      if (hour !== 12) {
        hour += 12;
      }
    }
    return hour;
  };

  const handleTimeApplyClick = (hour: number, minute: number, second: number, am: boolean) => {
    noSave(true);
    hour = correctHour(am, hour);
    let newTime = componentDate as Date | number;
    newTime = DateFns.setHours(newTime, hour);
    newTime = DateFns.setMinutes(newTime, minute);
    newTime = DateFns.setSeconds(newTime, second);
    setComponentDate(newTime);
    if(practiceDataUpdate){
      
      if (!!practiceDataUpdate && !isEmptyObject(practiceDataUpdate) && !!practiceDataUpdate._id && newTime) {
        const currentDate = new Date();
        if (DateFns.isAfter(newTime, currentDate) || DateFns.isSameDay(newTime, currentDate)) {
          practiceDataUpdate.start = DateFns.getTime(newTime);
          updatePracticeData(practiceDataUpdate);
          cleanControllerSet(CONTROLLER_SET);
        } else {
          alert('Please enter a future day.');
        }
      } else {
        console.info('not able to save on edit button', practiceDataUpdate);
      }
    }else{
      if (!!currentPractice && !isEmptyObject(currentPractice) && !!currentPractice._id && newTime) {
        const currentDate = new Date();
        if (DateFns.isAfter(newTime, currentDate) || DateFns.isSameDay(newTime, currentDate)) {
          currentPractice.start = DateFns.getTime(newTime);
          updatePracticeData(currentPractice);
          cleanControllerSet(CONTROLLER_SET);
        } else {
          alert('Please enter a future day.');
        }
      } else {
        console.info('not able to save on edit button', currentPractice);
      }
    }
  };
  
  const setDateHandler = (enteredDate: Date | number) => {
    noSave(true);
    let newDate = componentDate as Date | number;
    newDate = DateFns.setYear(newDate, DateFns.getYear(enteredDate));
    newDate = DateFns.setMonth(newDate, DateFns.getMonth(enteredDate));
    newDate = DateFns.setDate(newDate, DateFns.getDate(enteredDate));
    if(practiceDataUpdate){
      
      if (!!practiceDataUpdate && !isEmptyObject(practiceDataUpdate) && !!practiceDataUpdate._id && newDate) {
        const currentDate = new Date();
        if (DateFns.isAfter(newDate, currentDate) || DateFns.isSameDay(newDate, currentDate)) {
          setComponentDate(newDate);
          practiceDataUpdate.start = DateFns.getTime(newDate);
          //editPracticeTime(practiceDataUpdate, practiceDataUpdate._id, practiceDataUpdate.league);
          updatePracticeData(practiceDataUpdate);
          cleanControllerSet(CONTROLLER_SET);
        } else {
          alert('Please enter a future day.');
        }
      } else {
        console.info('not able to save on edit button', practiceDataUpdate);
      }
    }else{
      if (!!currentPractice && !isEmptyObject(currentPractice) && !!currentPractice._id && newDate) {
        const currentDate = new Date();
        if (DateFns.isAfter(newDate, currentDate) || DateFns.isSameDay(newDate, currentDate)) {
          setComponentDate(newDate);
          currentPractice.start = DateFns.getTime(newDate);
          //editPracticeTime(currentPractice, currentPractice._id, currentPractice.league);
          updatePracticeData(currentPractice);
          cleanControllerSet(CONTROLLER_SET);
        } else {
          alert('Please enter a future day.');
        }
      } else {
        console.info('not able to save on edit button', currentPractice);
      }
    }
  };

  return (
   <>
   <div className="time-edit-title" >{`Edit Scheduled Date & Time`}</div>
          <div className="timep time-edit-body" style={ {marginTop:'-15px', marginRight:'-40px'}} >
          <DatePicker date={componentDate as Date | number} setDate={setDateHandler} />
            <TimeSelector
              time={componentDate as number | Date} applyChanges={handleTimeApplyClick}
              customStyle={{ fontWeight: 'bold', backgroundColor: 'white', border: '1px solid #57636F' }}
            />
            </div>
   </>
  );
};

export default EditStartTimeButton;
